'use client';

import { useCallback, useState } from 'react';

import { useStore } from '@nanostores/react';
import { useIdleTimer } from 'react-idle-timer';

import { sessionStore, signOutSession } from '@/entities/session';

import { SessionTimeoutDialog } from './SessionTimeoutDialog';

const IDLE_TIMEOUT_MS = 30 * 60 * 1000;
const PROMPT_BEFORE_IDLE_MS = 2 * 60 * 1000;
const COUNTDOWN_TICK_MS = 1000;

export function SessionTimeoutHost() {
  const session = useStore(sessionStore);
  const enabled = session.status === 'authenticated';

  const [remainingMs, setRemainingMs] = useState(0);

  const onIdle = useCallback(() => {
    void signOutSession();
  }, []);

  const { isPrompted, activate, getRemainingTime } = useIdleTimer({
    timeout: IDLE_TIMEOUT_MS,
    promptBeforeIdle: PROMPT_BEFORE_IDLE_MS,
    onPrompt: () => {
      setRemainingMs(getRemainingTime());
    },
    onIdle,
    onActive: () => {
      setRemainingMs(0);
    },
    startOnMount: enabled,
    disabled: !enabled,
    throttle: 1000,
  });

  useIdleTimer({
    timeout: COUNTDOWN_TICK_MS,
    onIdle: () => {
      if (isPrompted()) {
        setRemainingMs(getRemainingTime());
      }
    },
    startOnMount: enabled && isPrompted(),
    disabled: !enabled,
    startManually: false,
    stopOnIdle: false,
  });

  const open = enabled && isPrompted();

  const handleStaySignedIn = useCallback(() => {
    activate();
    setRemainingMs(0);
  }, [activate]);

  const handleLogoutNow = useCallback(() => {
    void signOutSession();
  }, []);

  return (
    <SessionTimeoutDialog
      open={open}
      remainingMs={remainingMs}
      onStaySignedIn={handleStaySignedIn}
      onLogoutNow={handleLogoutNow}
    />
  );
}
